module.exports = __webpack_public_path__ + "img/comment-altActive.c57b6e32.svg";